<template>
  <div class="account" :class="{ 'with-avatar': hasAvatar }">
    <template v-if="isLoggedIn">
      <figure :style="styleObject" v-if="hasAvatar"></figure>
      <span>{{ account?.name }}</span>
    </template>
    <template v-else>
      <span>{{ $t('Not logged into portal') }}</span>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { $t } from '/@/i18n'
import { computed } from 'vue'
import { useAccount } from '/@/shared/composables/account'

const { account, isLoggedIn, hasAvatar } = useAccount()

const styleObject = computed(() => {
  return {
    backgroundImage: `url(${account.value?.avatar})`,
  }
})
</script>
<style src="./style.css"></style>
